import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";

import { FaClipboardCheck } from "react-icons/fa6";
import { FiBookOpen } from "react-icons/fi";
import { GoDotFill } from "react-icons/go";

import Navbar from "../components/Navbar";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

import { courses } from "../lib/data";
import { nigerianCurrency } from "../lib/formatter";

const CourseDetailPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { id } = useParams();

    const course = courses.find(course => course.id === Number(id));
    const courseTitle = course.name.split(" - ")[0];
    const percentDiscount = (course.price - course.discountedPrice) / course.price * 100;

    return (
        <>
            <Navbar />

            <section id='body-wrap' className="course-detail-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 wow bounceIn">
                            <h2 className="text-uppercase">COURSE DETAILS</h2>
                            <hr />
                            <div className="course-detail-header col-lg-8 col-sm-12 wow fadeInLeft" data-wow-delay="0.3s">
                                <h3 className="text-uppercase">{courseTitle}</h3>
                                <p><i>{course.description}</i></p>
                                <div className="academy-info">
                                    <img src={`${process.env.PUBLIC_URL}/images/logo-only.png`} alt="BrainyTech Logo" className="academy-logo" />
                                    <span className="academy-name"><b>Instructor: </b> BrainyTech Academy Top Instructor</span>
                                </div>

                                <div className="row mt-10">
                                    <div className="col-md-4 col-sm-6">
                                        <Link to="https://forms.gle/yzfdeDki6QaSvDv19" className="btn course-details-btn wow fadeInLeft" data-wow-delay="0.3s">
                                            <p className="enroll-text">ENROLL NOW</p>
                                            <p className="enroll-date"> Starts {course.startDate}</p>
                                        </Link>
                                    </div>

                                    <div className="col-md-8 col-sm-6 text-left">
                                        {
                                            percentDiscount ? (
                                                <span className="course-discount fadeInRight" data-wow-delay="0.3s">
                                                    <del style={{ color: "red" }}>{nigerianCurrency.format(course.price)}</del> {nigerianCurrency.format(course.discountedPrice)} <i>({percentDiscount}% Off - Limited Time Offer)</i>
                                                </span>
                                            ) : (
                                                <span className="course-discount fadeInRight" data-wow-delay="0.3s">
                                                    {nigerianCurrency.format(course.price)}
                                                </span>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="course-attribute-container text-center my-30 wow bounceIn">
                        <div className="row">
                            <div className="course-attribute col-md-3 col-sm-6">
                                <p className="subheading">{course.modules.length} Module Course</p>
                                <p className="small-font">{course.snippets.goal}</p>
                            </div>

                            <div className="course-attribute col-md-3 col-sm-6">
                                <p className="subheading">{course.snippets.experience}</p>
                                <p className="small-font">Recommended Experience</p>
                            </div>

                            <div className="course-attribute col-md-2 col-sm-6">
                                <p className="subheading">Duration</p>
                                <p className="small-font">{course.snippets.duration}</p>
                            </div>

                            <div className="course-attribute col-md-2 col-sm-6">
                                <p className="subheading">Certificate</p>
                                <p className="small-font">{course.snippets.certificate}</p>
                            </div>

                            <div className="course-attribute col-md-2 col-sm-6">
                                <p className="subheading">Language(s)</p>
                                <p className="small-font">Taught in {course.snippets.languages.map(language => language)}</p>
                            </div>
                        </div>
                    </div>

                    <p className="heading mx-20">What you'll learn...</p>
                    <div className="row mx-10">
                        {
                            course.skills.map(skill => (
                                <div className="col-md-4 col-sm-6">
                                    <p className="skills">
                                        <span><FaClipboardCheck color="#55acee" className="skills-icon" /></span>
                                        <span className="">{skill}</span>
                                    </p>
                                </div>
                            ))
                        }

                    </div>

                    <p className="course-name">{course.name}</p>
                    <div className="row mx-20">
                        {
                            course.modules.map(module => (
                                <div className="module-div mb-20">
                                    <div><FiBookOpen className="module-icon" /></div>
                                    <div>
                                        <p className="module-heading">{module.title}</p>
                                        {
                                            module.contents.map(content => (
                                                <p className="module-content-p">
                                                    <span className="mx-10"><GoDotFill color="#55acee" /></span>
                                                    <span className="module-content">{content}</span>
                                                </p>
                                            ))
                                        }

                                    </div>
                                </div>
                            ))
                        }
                    </div>

                    {/* ENROLLMENT BUTTON */}
                    <div className="row my-20">
                        <div className="col-md-3 col-sm-6">
                            <Link to="https://forms.gle/yzfdeDki6QaSvDv19" className="btn course-details-btn wow fadeInLeft" data-wow-delay="0.3s">
                                <p className="enroll-text">ENROLL NOW</p>
                                <p className="enroll-date">Starts {course.startDate}</p>
                            </Link>
                        </div>

                        <div className="col-md-6 col-sm-6">
                            {
                                percentDiscount ? (
                                    <span className="course-discount fadeInRight" data-wow-delay="0.3s">
                                        <del style={{ color: "red" }}>{nigerianCurrency.format(course.price)}</del> {nigerianCurrency.format(course.discountedPrice)} <i>({percentDiscount}% Off - Limited Time Offer)</i>
                                    </span>
                                ) : (
                                    <span className="course-discount fadeInRight" data-wow-delay="0.3s">
                                        {nigerianCurrency.format(course.price)}
                                    </span>
                                )
                            }
                        </div>
                    </div>
                </div>

            </section >

            <Contact />

            <Footer />
        </>
    )
}

export default CourseDetailPage